import { useEffect, useState } from 'react';
import { Col, Row } from "reactstrap";
import EnterpriseService from '../../common/services/enterprise-service';
import SingleMemberBadge from './SingleMemberBadge';

const MemberBadges = ({ company, container, month, year }) => {

    const es = new EnterpriseService();
    const [badges, setBadges] = useState([]);

    useEffect(async () => {
        const result = await es.getMembersBadgesMonthly(company, month, year);
        setBadges(result);
    }, [month, year]);

    return (
        <>
            {badges.length > 0 &&
                <Row className="g-2 mt-3">
                    {badges.map((m) => (
                        <Col key={`${m.badge_type}`} xs={12} md={6} xl={4}>
                            <SingleMemberBadge container={container} badge={m} />
                        </Col>
                    ))}
                </Row>
            }
        </>
    );
};

export default MemberBadges;